<template>
  <div class="l-page l-page--message">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">

      <div class="l-main-head">

        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">編集ログ</div>
        </div>

      </div>

      <div class="l-main-content">
        <div class="p-message-result">

          <div>ログは5分ごとに更新しております</div>
          <div class="p-message-result__data" :class="{'is-loading': isLoading, 'is-empty': isEmpty, 'is-loaded': !isEmpty && isLoaded }">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">閲覧できる編集ログがありません</div>
            </div>
            <table class="c-table">
              <thead>
                <tr>
                  <th class="c-table__cell--center u-w100 is-sortable" style="padding: 15px !important;">
                    <span class="c-table__text">ユーザID</span>
                  </th>
                  <th class="c-table__cell--center u-w100 is-sortable">
                    <span class="c-table__text">ユーザ名</span>
                  </th>
                  <th class="c-table__cell--center u-w100 is-sortable">
                    <span class="c-table__text">操作対象ID</span>
                  </th>
                  <th class="c-table__cell--center u-w100 is-sortable">
                    <span class="c-table__text">操作対象</span>
                  </th>
                  <th class="c-table__cell--center u-w100 is-sortable">
                    <span class="c-table__text">操作内容</span>
                  </th>
                  <th class="c-table__cell--center u-w100 is-sortable">
                    <span class="c-table__text">操作日時</span>
                  </th>
                  <th class="c-table__cell--center u-w100 is-sortable">
                    <span class="c-table__text">変更箇所</span>
                  </th>
                </tr>
              </thead>

              <!-- 編集ログリスト -->
              <action-log-list-item
                v-for="(actionLog, index) in actionLogs.data"
                :key="index"
                :action-log="actionLog"
                :action-log-info="actionLogInfo"
              />
              <!-- /編集ログリスト -->
            </table>
            <pagination v-if="paginationInfo" :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
          </div>

        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    actionLogInfo: Object,
  },
  data () {
    return {
      actionLogs: [],
      paginationInfo: null,

      // フラグ系
      isLoading: false,
      isLoaded: false,
      isEmpty: false,
      errorMessage: '',
    }
  },
  mounted: function() {
    this.loadData();
  },
  methods: {
    loadData: function() {

      // 情報取得用パラメタ作成
      const params = {
        params: {
          page: this.page,
        }
      };

      this.isLoading = true;
      this.isLoaded = false;

      // 配信グループデータの取得処理実行
      axios.get('/api/action-log/list', params)
        .then(res => {
          this.actionLogs = res.data.actionLogs;
          this.paginationInfo = res.data.actionLogs;
          setTimeout(() => {
            this.isLoading = false;
            this.isLoaded = true;
            this.isEmpty = (res.data.actionLogs.data.length < 1);
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          setTimeout(() => {
            this.isError = true;
            this.errorMessage = '編集ログの取得時にエラーが発生しました'
            this.isLoading = false;
          }, 300);
        });
    },
    onPageClick: function(clickPage) {
      this.page = clickPage;
      this.loadData();
    },
  }

}
</script>
